export default __webpack_public_path__ + "static/media/LogoHarfonIngles.c0d11ab4.png";